import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "spinner"]
  spinner = null

  connect() {
    console.log("[TabLoader] Controller connected")
    this.element.addEventListener('turbo:before-fetch-request', this.showSpinner.bind(this))
    this.element.addEventListener('turbo:before-fetch-response', this.hideSpinner.bind(this))
  }

  disconnect() {
    console.log("[TabLoader] Controller disconnected")
    this.element.removeEventListener('turbo:before-fetch-request', this.showSpinner.bind(this))
    this.element.removeEventListener('turbo:before-fetch-response', this.hideSpinner.bind(this))
    if (this.spinner) {
      this.spinner.stop()
    }
  }

  showSpinner() {
    console.log("[TabLoader] Showing spinner")
    const opts = {
      lines: 13,      // The number of lines to draw
      length: 40,     // The length of each line
      width: 15,      // The line thickness
      radius: 40,     // The radius of the inner circle
      corners: 1,     // Corner roundness (0..1)
      rotate: 0,      // The rotation offset
      direction: 1,   // 1: clockwise, -1: counterclockwise
      color: '#f57921',  // #rgb or #rrggbb or array of colors
      speed: 1,       // Rounds per second
      trail: 60,      // Afterglow percentage
      shadow: false,  // Whether to render a shadow
      hwaccel: false, // Whether to use hardware acceleration
      className: 'spinner', // The CSS class to assign to the spinner
      zIndex: 2e9,    // The z-index (defaults to 2000000000)
      top: '50%',     // Top position relative to parent
      left: '50%'     // Left position relative to parent
    }

    try {
      // Use the same spinner implementation as btn-spin-js
      const $spinBox = $('.spin-box')
      $spinBox.hide()
      $('body').addClass('spin-box-open')
      this.spinner = new window.Spinner(opts)
      const spinnerEl = this.spinner.spin($spinBox[0]).el
      $spinBox.append(spinnerEl)
      $spinBox.show()
      console.log("[TabLoader] Spinner added to target:", $spinBox[0])
    } catch (error) {
      console.error("[TabLoader] Error creating spinner:", error)
    }
  }

  hideSpinner() {
    console.log("[TabLoader] Hiding spinner")
    if (this.spinner) {
      this.spinner.stop()
      this.spinner = null
    }
    $('body').removeClass('spin-box-open')
    $('.spin-box').hide()
  }
}
